// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_2wiAz","buttonWrapper":"_2wiAz","dot":"_1azp8"};